import { connectFela } from '../../dependencies';
import Modal from './Modal';
import * as styles from './Modal.styles';

export default connectFela(styles)(Modal);
